// import { useState, useEffect, useCallback } from "react";
// import ChatHistoryApi from "../api/ChatHistoryApi";
// import { ChatHistoryItem } from "../types/ChatHistoryTypes";
// import { useAuth } from "../context/AuthContext";
// import { PROJECT_ID } from "../config";
// import { toast } from "react-toastify";
// import { ERROR_MESSAGES, SUCCESS_MESSAGES, RECENT_CHAT_DAYS, OLDER_CHAT_DAYS } from "../utils/constants";

// export const UseChatHistory = () => {
//   const [recentChats, setRecentChats] = useState<ChatHistoryItem[]>([]);
//   const [olderChats, setOlderChats] = useState<ChatHistoryItem[]>([]);
//   const [allOlderChats, setAllOlderChats] = useState<ChatHistoryItem[]>([]);
//   const [loading, setLoading] = useState<boolean>(true);
//   const { getAccessToken, account } = useAuth();

//     const renameChat = useCallback(
//       async (conversationId: string, newName: string) => {
//         try {
//           const token = await getAccessToken();
//           await ChatHistoryApi.updateSession(conversationId, newName, token || undefined);
//           // Update local state
//           const updateName = (chats: ChatHistoryItem[]) =>
//             chats.map((c) => c.id === conversationId ? { ...c, title: newName } : c);
//           setRecentChats((prev) => updateName(prev));
//           setOlderChats((prev) => updateName(prev));
//           setAllOlderChats((prev) => updateName(prev));
//           toast.success(SUCCESS_MESSAGES.SESSION_RENAMED);
//         } catch (err) {
//           toast.error(ERROR_MESSAGES.RENAME_SESSION_FAILED);
//           throw err;
//         }
//       },
//       [getAccessToken]
//     );

//   // Get user_id from logged-in MSAL account
//   const userId = account?.localAccountId || account?.homeAccountId;

//   // Project id is static from env
//   const projectId = PROJECT_ID || null;

//   const fetchRecentChats = useCallback(async () => {
//     if (!userId || !projectId) {
//       setLoading(false);
//       return;
//     }

//     setLoading(true);
//     try {
//       const token = await getAccessToken();
//       const res = await ChatHistoryApi.getSessionsByDays(
//         userId,
//         projectId,
//         RECENT_CHAT_DAYS,
//         token || undefined
//       );
//       // Map backend response to ChatHistoryItem format
//       const raw = res.data;
//       const sessions: any[] = Array.isArray(raw)
//         ? raw
//         : Array.isArray(raw?.sessions)
//         ? raw.sessions
//         : [];
//       const mapped: ChatHistoryItem[] = sessions.map((session: any) => ({
//         id: session.session_id,
//         conversationId: session.session_id,
//         title: session.session_name || "Untitled Chat",
//         // Some responses don't include created_at; fallback to now to satisfy type
//         createdAt:
//           session.created_at || session.createdAt || new Date().toISOString(),
//       }));
//       setRecentChats(mapped);
//     } catch (err) {
//       toast.error(ERROR_MESSAGES.LOAD_SESSIONS_FAILED);
//       setRecentChats([]);
//     } finally {
//       setLoading(false);
//     }
//   }, [getAccessToken, userId, projectId]);

//   const fetchOlderChats = useCallback(async () => {
//     if (!userId || !projectId) {
//       return;
//     }

//     try {
//       const token = await getAccessToken();
//       const res = await ChatHistoryApi.getSessionsByDays(
//         userId,
//         projectId,
//         OLDER_CHAT_DAYS,
//         token || undefined
//       );
//       const raw = res.data;
//       const sessions: any[] = Array.isArray(raw)
//         ? raw
//         : Array.isArray(raw?.sessions)
//         ? raw.sessions
//         : [];
//       const mapped: ChatHistoryItem[] = sessions.map((session: any) => ({
//         id: session.session_id,
//         conversationId: session.session_id,
//         title: session.session_name || "Untitled Chat",
//         createdAt:
//           session.created_at || session.createdAt || new Date().toISOString(),
//       }));
//       setOlderChats(mapped);
//     } catch (err) {
//       setOlderChats([]);
//     }
//   }, [getAccessToken, userId, projectId]);

//   const fetchAllOlderChats = useCallback(async () => {
//     if (!userId || !projectId) {
//       return;
//     }

//     try {
//       const token = await getAccessToken();
//       const res = await ChatHistoryApi.getSessionsByDays(
//         userId,
//         projectId,
//         365,
//         token || undefined
//       );
//       const raw = res.data;
//       const sessions: any[] = Array.isArray(raw)
//         ? raw
//         : Array.isArray(raw?.sessions)
//         ? raw.sessions
//         : [];
//       const mapped: ChatHistoryItem[] = sessions.map((session: any) => ({
//         id: session.session_id,
//         conversationId: session.session_id,
//         title: session.session_name || "Untitled Chat",
//         createdAt:
//           session.created_at || session.createdAt || new Date().toISOString(),
//       }));
//       setAllOlderChats(mapped);
//     } catch (err) {
//       setAllOlderChats([]);
//     }
//   }, [getAccessToken, userId, projectId]);

//   const fetchAll = useCallback(async () => {
//     await Promise.all([fetchRecentChats(), fetchOlderChats(), fetchAllOlderChats()]);
//   }, [fetchRecentChats, fetchOlderChats, fetchAllOlderChats]);

//     const deleteChat = useCallback(
//     async (conversationId: string) => {
//       try {
//         const token = await getAccessToken();
//         await ChatHistoryApi.deleteSession(conversationId, token || undefined);
//         toast.success(SUCCESS_MESSAGES.SESSION_DELETED);
//       } catch (err) {
//         toast.error(ERROR_MESSAGES.DELETE_SESSION_FAILED);
//       }
//       setRecentChats((prev) => prev.filter((c) => c.id !== conversationId));
//       setOlderChats((prev) => prev.filter((c) => c.id !== conversationId));
//       setAllOlderChats((prev) => prev.filter((c) => c.id !== conversationId));
//     },
//     [getAccessToken]
//   );  const saveChat = useCallback(
//     async (payload: any) => {
//       // saveChat method removed - no longer needed
//       await fetchAll();
//     },
//     [fetchAll]
//   );

//   // Fetch chats when projectId is available
//   useEffect(() => {
//     if (projectId) {
//       fetchRecentChats();
//     }
//   }, [projectId, fetchRecentChats]);

//   // Combine all for backward compatibility
//   const chats = [...recentChats, ...olderChats, ...allOlderChats];

//   return {
//     chats,
//     recentChats,
//     olderChats,
//     allOlderChats,
//     loading,
//     fetchAll,
//     fetchRecentChats,
//     fetchOlderChats,
//     fetchAllOlderChats,
//     deleteChat,
//     saveChat,
//       renameChat,
//   };
// };

// export default UseChatHistory;


// import { useState, useEffect, useCallback } from "react";
// import ChatHistoryApi from "../api/ChatHistoryApi";
// import { ChatHistoryItem } from "../types/ChatHistoryTypes";
// import { useAuth } from "../context/AuthContext";
// import { PROJECT_ID } from "../config";
// import { toast } from "react-toastify";
// import {
//   ERROR_MESSAGES,
//   SUCCESS_MESSAGES,
//   RECENT_CHAT_DAYS,
//   OLDER_CHAT_DAYS,
// } from "../utils/constants";

// export const UseChatHistory = () => {
//   const { getAccessToken, account } = useAuth();

//   const [recentChats, setRecentChats] = useState<ChatHistoryItem[]>([]);
//   const [olderChats, setOlderChats] = useState<ChatHistoryItem[]>([]);
//   const [allOlderChats, setAllOlderChats] = useState<ChatHistoryItem[]>([]);
//   const [loading, setLoading] = useState(false);

//   // Track pagination state for each section
//   const [hasMoreRecent, setHasMoreRecent] = useState(false);
//   const [hasMoreOlder, setHasMoreOlder] = useState(false);
//   const [hasMoreAllOlder, setHasMoreAllOlder] = useState(false);

//   // Track offsets for pagination
//   const [recentOffset, setRecentOffset] = useState(0);
//   const [olderOffset, setOlderOffset] = useState(0);
//   const [allOlderOffset, setAllOlderOffset] = useState(0);

//   const userId = account?.localAccountId || account?.homeAccountId;
//   const projectId = PROJECT_ID;

//   /* ---------------- helpers ---------------- */

//   const startOfDay = (d: Date) =>
//     new Date(d.getFullYear(), d.getMonth(), d.getDate());

//   /**
//    * Backend sends:
//    * last_message_at: "2025-12-05T13:13:30.564183+00:00"
//    * We always return a STRING to satisfy ChatHistoryItem
//    */
//   const mapSessions = (sessions: any[]): ChatHistoryItem[] =>
//     sessions.map((s) => {
//       let createdAt = new Date().toISOString(); // ✅ fallback (never null)

//       if (s.last_message_at) {
//         const date = new Date(s.last_message_at);
//         if (!isNaN(date.getTime())) {
//           createdAt = date.toISOString();
//         }
//       }

//       return {
//         id: s.session_id,
//         conversationId: s.session_id,
//         title: s.session_name || "Untitled Chat",
//         createdAt,
//       };
//     });

//   /* ---------- Fetch by days with pagination ---------- */
//   const fetchByDaysWithPagination = useCallback(
//     async (days: number, offset: number = 0, limit: number = 50) => {
//       if (!userId || !projectId) return { sessions: [], hasMore: false };

//       const token = await getAccessToken();
//       const res = await ChatHistoryApi.getSessionsByDays(
//         userId,
//         projectId,
//         days,
//         token || undefined,
//         offset,
//         limit
//       );

//       const raw = res?.data;
//       const sessions = Array.isArray(raw)
//         ? raw
//         : Array.isArray(raw?.sessions)
//         ? raw.sessions
//         : [];

//       const hasMore = raw?.has_more || false;

//       return { sessions: mapSessions(sessions), hasMore };
//     },
//     [getAccessToken, userId, projectId]
//   );

//   /* ---------- Fetch all sections with pagination ---------- */
//   const fetchAll = useCallback(async () => {
//     if (!userId || !projectId) {
//       setLoading(false);
//       return;
//     }

//     setLoading(true);
//     try {
//       // Fetch all sessions at once (1000 days) for better accuracy
//       // This ensures older sessions are included without duplicates across API calls
//       const allRes = await fetchByDaysWithPagination(1000, 0, 150); // Fetch 150 to cover all categories

//       const today = startOfDay(new Date());

//       // Filter into distinct, non-overlapping categories based on actual dates
//       const recent: ChatHistoryItem[] = [];
//       const older: ChatHistoryItem[] = [];
//       const allOlder: ChatHistoryItem[] = [];

//       allRes.sessions.forEach((session) => {
//         const sessionDate = startOfDay(new Date(session.createdAt));
//         const diffDays = Math.floor((today.getTime() - sessionDate.getTime()) / (1000 * 60 * 60 * 24));

//         if (diffDays <= RECENT_CHAT_DAYS) {
//           recent.push(session);
//         } else if (diffDays <= OLDER_CHAT_DAYS) {
//           older.push(session);
//         } else {
//           allOlder.push(session);
//         }
//       });

//       // Show "Show More" only if there are more than 50 items in each category
//       setRecentChats(recent);
//       setHasMoreRecent(recent.length > 50);
//       setRecentOffset(50);

//       setOlderChats(older);
//       setHasMoreOlder(older.length > 50);
//       setOlderOffset(50);

//       setAllOlderChats(allOlder);
//       setHasMoreAllOlder(allOlder.length > 50);
//       setAllOlderOffset(50);
//     } catch (err) {
//       console.error("Error fetching chat history:", err);
//       toast.error(ERROR_MESSAGES.LOAD_SESSIONS_FAILED);
//       setRecentChats([]);
//       setOlderChats([]);
//       setAllOlderChats([]);
//       setHasMoreRecent(false);
//       setHasMoreOlder(false);
//       setHasMoreAllOlder(false);
//     } finally {
//       setLoading(false);
//     }
//   }, [userId, projectId, fetchByDaysWithPagination]);

//   /* ---------- Load more for each section ---------- */
//   const loadMoreRecent = useCallback(async () => {
//     if (!userId || !projectId) return;

//     try {
//       const res = await fetchByDaysWithPagination(1000, recentOffset, 50);
//       const today = startOfDay(new Date());

//       // Filter new sessions into appropriate categories
//       const newSessions = res.sessions.filter((session) => {
//         const sessionDate = startOfDay(new Date(session.createdAt));
//         const diffDays = Math.floor((today.getTime() - sessionDate.getTime()) / (1000 * 60 * 60 * 24));
//         return diffDays <= RECENT_CHAT_DAYS;
//       });

//       setRecentChats((prev) => [...prev, ...newSessions]);
//       setHasMoreRecent(res.hasMore);
//       setRecentOffset((prev) => prev + 50);
//     } catch (err) {
//       toast.error(ERROR_MESSAGES.LOAD_SESSIONS_FAILED);
//     }
//   }, [userId, projectId, recentOffset, fetchByDaysWithPagination]);

//   const loadMoreOlder = useCallback(async () => {
//     if (!userId || !projectId) return;

//     try {
//       const res = await fetchByDaysWithPagination(1000, olderOffset, 50);
//       const today = startOfDay(new Date());

//       // Filter new sessions into appropriate categories
//       const newSessions = res.sessions.filter((session) => {
//         const sessionDate = startOfDay(new Date(session.createdAt));
//         const diffDays = Math.floor((today.getTime() - sessionDate.getTime()) / (1000 * 60 * 60 * 24));
//         return diffDays > RECENT_CHAT_DAYS && diffDays <= OLDER_CHAT_DAYS;
//       });

//       setOlderChats((prev) => [...prev, ...newSessions]);
//       setHasMoreOlder(res.hasMore);
//       setOlderOffset((prev) => prev + 50);
//     } catch (err) {
//       toast.error(ERROR_MESSAGES.LOAD_SESSIONS_FAILED);
//     }
//   }, [userId, projectId, olderOffset, fetchByDaysWithPagination]);

//   const loadMoreAllOlder = useCallback(async () => {
//     if (!userId || !projectId) return;

//     try {
//       const res = await fetchByDaysWithPagination(1000, allOlderOffset, 50);
//       const today = startOfDay(new Date());

//       // Filter new sessions into appropriate categories
//       const newSessions = res.sessions.filter((session) => {
//         const sessionDate = startOfDay(new Date(session.createdAt));
//         const diffDays = Math.floor((today.getTime() - sessionDate.getTime()) / (1000 * 60 * 60 * 24));
//         return diffDays > OLDER_CHAT_DAYS;
//       });

//       setAllOlderChats((prev) => [...prev, ...newSessions]);
//       setHasMoreAllOlder(res.hasMore);
//       setAllOlderOffset((prev) => prev + 50);
//     } catch (err) {
//       toast.error(ERROR_MESSAGES.LOAD_SESSIONS_FAILED);
//     }
//   }, [userId, projectId, allOlderOffset, fetchByDaysWithPagination]);

//   /* ---------- Rename ---------- */

//   /* ---------- Rename chat ---------- */

//   const renameChat = useCallback(
//     async (conversationId: string, newName: string) => {
//       try {
//         const token = await getAccessToken();
//         await ChatHistoryApi.updateSession(
//           conversationId,
//           newName,
//           token || undefined
//         );

//         const update = (list: ChatHistoryItem[]) =>
//           list.map((c) =>
//             c.id === conversationId ? { ...c, title: newName } : c
//           );

//         setRecentChats(update);
//         setOlderChats(update);
//         setAllOlderChats(update);

//         toast.success(SUCCESS_MESSAGES.SESSION_RENAMED);
//       } catch {
//         toast.error(ERROR_MESSAGES.RENAME_SESSION_FAILED);
//       }
//     },
//     [getAccessToken]
//   );

//   /* ---------------- delete chat ---------------- */

//   const deleteChat = useCallback(
//     async (conversationId: string) => {
//       try {
//         const token = await getAccessToken();
//         await ChatHistoryApi.deleteSession(
//           conversationId,
//           token || undefined
//         );

//         setRecentChats((p) => p.filter((c) => c.id !== conversationId));
//         setOlderChats((p) => p.filter((c) => c.id !== conversationId));
//         setAllOlderChats((p) => p.filter((c) => c.id !== conversationId));

//         toast.success(SUCCESS_MESSAGES.SESSION_DELETED);
//       } catch {
//         toast.error(ERROR_MESSAGES.DELETE_SESSION_FAILED);
//       }
//     },
//     [getAccessToken]
//   );

//   /* ---------------- auth-aware load ---------------- */

//   useEffect(() => {
//     if (userId && projectId) {
//       fetchAll();
//     }
//   }, [userId, projectId, fetchAll]);

//   return {
//     recentChats,
//     olderChats,
//     allOlderChats,
//     chats: [...recentChats, ...olderChats, ...allOlderChats],
//     loading,
//     fetchAll,
//     deleteChat,
//     renameChat,
//     hasMoreRecent,
//     hasMoreOlder,
//     hasMoreAllOlder,
//     loadMoreRecent,
//     loadMoreOlder,
//     loadMoreAllOlder,
//   };
// };

// export default UseChatHistory;

import { useState, useEffect, useCallback } from "react";
import ChatHistoryApi from "../api/ChatHistoryApi";
import { ChatHistoryItem } from "../types/ChatHistoryTypes";
import { useAuth } from "../context/AuthContext";
import { PROJECT_ID } from "../config";
import { toast } from "react-toastify";
import {
  ERROR_MESSAGES,
  SUCCESS_MESSAGES,
  RECENT_CHAT_DAYS,
  OLDER_CHAT_DAYS,
} from "../utils/constants";

const LIMIT = 50;

export const UseChatHistory = () => {
  const { getAccessToken, account } = useAuth();

  const userId = account?.localAccountId || account?.homeAccountId;
  const projectId = PROJECT_ID;

  const [recentChats, setRecentChats] = useState<ChatHistoryItem[]>([]);
  const [olderChats, setOlderChats] = useState<ChatHistoryItem[]>([]);
  const [allOlderChats, setAllOlderChats] = useState<ChatHistoryItem[]>([]);

  const [recentOffset, setRecentOffset] = useState(0);
  const [olderOffset, setOlderOffset] = useState(0);
  const [allOlderOffset, setAllOlderOffset] = useState(0);

  const [hasMoreRecent, setHasMoreRecent] = useState(false);
  const [hasMoreOlder, setHasMoreOlder] = useState(false);
  const [hasMoreAllOlder, setHasMoreAllOlder] = useState(false);

  const [loading, setLoading] = useState(false);

  // Loading states for "Show More" buttons
  const [loadingMoreRecent, setLoadingMoreRecent] = useState(false);
  const [loadingMoreOlder, setLoadingMoreOlder] = useState(false);
  const [loadingMoreAllOlder, setLoadingMoreAllOlder] = useState(false);

  // Track if sections have been fetched (for lazy loading)
  const [olderFetched, setOlderFetched] = useState(false);
  const [allOlderFetched, setAllOlderFetched] = useState(false);

  // Loading states for initial section fetch (on expand)
  const [loadingOlderSection, setLoadingOlderSection] = useState(false);
  const [loadingAllOlderSection, setLoadingAllOlderSection] = useState(false);

  /* ---------- helpers ---------- */

  const mapSessions = (sessions: any[]): ChatHistoryItem[] =>
    sessions.map((s) => ({
      id: s.session_id,
      conversationId: s.session_id,
      title: s.session_name || "Untitled Chat",
      createdAt: new Date(s.last_message_at).toISOString(),
    }));

  const bucket = (sessions: ChatHistoryItem[]) => {
    const now = Date.now();
    const dayMs = 86400000;

    const recent: ChatHistoryItem[] = [];
    const previous30: ChatHistoryItem[] = [];
    const older: ChatHistoryItem[] = [];

    sessions.forEach((s) => {
      const diff = Math.floor((now - new Date(s.createdAt).getTime()) / dayMs);

      if (diff <= RECENT_CHAT_DAYS) recent.push(s);
      else if (diff <= OLDER_CHAT_DAYS) previous30.push(s);
      else older.push(s);
    });

    return { recent, previous30, older };
  };

  /* ---------- Separate fetch functions for each section with distinct date ranges ---------- */

  // Previous 7 Days: 0 to RECENT_CHAT_DAYS days ago
  const fetchRecentChats = useCallback(async (offset: number = 0) => {
    if (!userId || !projectId) return { sessions: [], hasMore: false };

    const token = await getAccessToken();
    const now = Date.now();
    const dayMs = 86400000;

    // End date: tomorrow (to include today fully)
    const endDate = new Date(now + dayMs).toISOString().split("T")[0];
    // Start date: RECENT_CHAT_DAYS days ago
    const startDate = new Date(now - RECENT_CHAT_DAYS * dayMs).toISOString().split("T")[0];

    const res = await ChatHistoryApi.getSessions(
      {
        user_id: userId,
        project_id: projectId,
        start_date: startDate,
        end_date: endDate,
        offset,
        limit: LIMIT,
      },
      { accessToken: token ?? undefined }
    );

    return {
      sessions: mapSessions(res?.data?.sessions ?? []),
      hasMore: res?.data?.has_more ?? false,
    };
  }, [userId, projectId, getAccessToken]);

  // Previous 30 Days: RECENT_CHAT_DAYS+1 to OLDER_CHAT_DAYS days ago
  const fetchOlderChats = useCallback(async (offset: number = 0) => {
    if (!userId || !projectId) return { sessions: [], hasMore: false };

    const token = await getAccessToken();
    const now = Date.now();
    const dayMs = 86400000;

    // End date: RECENT_CHAT_DAYS days ago (exclusive of recent)
    const endDate = new Date(now - RECENT_CHAT_DAYS * dayMs).toISOString().split("T")[0];
    // Start date: OLDER_CHAT_DAYS days ago
    const startDate = new Date(now - OLDER_CHAT_DAYS * dayMs).toISOString().split("T")[0];

    const res = await ChatHistoryApi.getSessions(
      {
        user_id: userId,
        project_id: projectId,
        start_date: startDate,
        end_date: endDate,
        offset,
        limit: LIMIT,
      },
      { accessToken: token ?? undefined }
    );

    return {
      sessions: mapSessions(res?.data?.sessions ?? []),
      hasMore: res?.data?.has_more ?? false,
    };
  }, [userId, projectId, getAccessToken]);

  // Older: beyond OLDER_CHAT_DAYS days ago (up to 365 days)
  const fetchAllOlderChats = useCallback(async (offset: number = 0) => {
    if (!userId || !projectId) return { sessions: [], hasMore: false };

    const token = await getAccessToken();
    const now = Date.now();
    const dayMs = 86400000;

    // End date: OLDER_CHAT_DAYS days ago (exclusive of previous 30)
    const endDate = new Date(now - OLDER_CHAT_DAYS * dayMs).toISOString().split("T")[0];
    // Start date: 365 days ago
    const startDate = new Date(now - 365 * dayMs).toISOString().split("T")[0];

    const res = await ChatHistoryApi.getSessions(
      {
        user_id: userId,
        project_id: projectId,
        start_date: startDate,
        end_date: endDate,
        offset,
        limit: LIMIT,
      },
      { accessToken: token ?? undefined }
    );

    return {
      sessions: mapSessions(res?.data?.sessions ?? []),
      hasMore: res?.data?.has_more ?? false,
    };
  }, [userId, projectId, getAccessToken]);

  /* ---------- initial load - only fetch Previous 7 Days by default ---------- */

  const fetchAll = useCallback(async () => {
    if (!userId || !projectId) return;

    setLoading(true);
    try {
      // Only fetch Previous 7 Days on initial load
      const recentResult = await fetchRecentChats(0);

      setRecentChats(recentResult.sessions);
      setRecentOffset(recentResult.sessions.length);
      setHasMoreRecent(recentResult.hasMore);

      // Reset older sections for fresh data when user expands them
      setOlderFetched(false);
      setAllOlderFetched(false);
      setOlderChats([]);
      setAllOlderChats([]);
    } catch {
      toast.error(ERROR_MESSAGES.LOAD_SESSIONS_FAILED);
    } finally {
      setLoading(false);
    }
  }, [userId, projectId, fetchRecentChats]);

  /* ---------- on-demand fetch for Previous 30 Days (when section is expanded) ---------- */

  const fetchOlderSection = useCallback(async () => {
    if (olderFetched || !userId || !projectId) return;

    setLoadingOlderSection(true);
    try {
      const result = await fetchOlderChats(0);
      setOlderChats(result.sessions);
      setOlderOffset(result.sessions.length);
      setHasMoreOlder(result.hasMore);
      setOlderFetched(true);
    } catch {
      toast.error(ERROR_MESSAGES.LOAD_SESSIONS_FAILED);
    } finally {
      setLoadingOlderSection(false);
    }
  }, [olderFetched, userId, projectId, fetchOlderChats]);

  /* ---------- on-demand fetch for Older (when section is expanded) ---------- */

  const fetchAllOlderSection = useCallback(async () => {
    if (allOlderFetched || !userId || !projectId) return;

    setLoadingAllOlderSection(true);
    try {
      const result = await fetchAllOlderChats(0);
      setAllOlderChats(result.sessions);
      setAllOlderOffset(result.sessions.length);
      setHasMoreAllOlder(result.hasMore);
      setAllOlderFetched(true);
    } catch {
      toast.error(ERROR_MESSAGES.LOAD_SESSIONS_FAILED);
    } finally {
      setLoadingAllOlderSection(false);
    }
  }, [allOlderFetched, userId, projectId, fetchAllOlderChats]);

  /* ---------- load more for each section ---------- */

  const loadMoreRecent = async () => {
    setLoadingMoreRecent(true);
    try {
      const { sessions, hasMore } = await fetchRecentChats(recentOffset);
      setRecentChats((p) => [...p, ...sessions]);
      setRecentOffset((p) => p + sessions.length);
      setHasMoreRecent(hasMore);
    } finally {
      setLoadingMoreRecent(false);
    }
  };

  const loadMoreOlder = async () => {
    setLoadingMoreOlder(true);
    try {
      const { sessions, hasMore } = await fetchOlderChats(olderOffset);
      setOlderChats((p) => [...p, ...sessions]);
      setOlderOffset((p) => p + sessions.length);
      setHasMoreOlder(hasMore);
    } finally {
      setLoadingMoreOlder(false);
    }
  };

  const loadMoreAllOlder = async () => {
    setLoadingMoreAllOlder(true);
    try {
      const { sessions, hasMore } = await fetchAllOlderChats(allOlderOffset);
      setAllOlderChats((p) => [...p, ...sessions]);
      setAllOlderOffset((p) => p + sessions.length);
      setHasMoreAllOlder(hasMore);
    } finally {
      setLoadingMoreAllOlder(false);
    }
  };

  /* ---------- rename ---------- */

  const renameChat = useCallback(
    async (conversationId: string, newName: string) => {
      const token = await getAccessToken();
      await ChatHistoryApi.updateSession(conversationId, newName, token ?? undefined);

      const update = (list: ChatHistoryItem[]) =>
        list.map((c) =>
          c.id === conversationId ? { ...c, title: newName } : c
        );

      setRecentChats(update);
      setOlderChats(update);
      setAllOlderChats(update);
      toast.success(SUCCESS_MESSAGES.SESSION_RENAMED);
    },
    [getAccessToken]
  );

  /* ---------- delete ---------- */

  const deleteChat = useCallback(
    async (conversationId: string) => {
      const token = await getAccessToken();
      await ChatHistoryApi.deleteSession(conversationId, token ?? undefined);

      setRecentChats((p) => p.filter((c) => c.id !== conversationId));
      setOlderChats((p) => p.filter((c) => c.id !== conversationId));
      setAllOlderChats((p) => p.filter((c) => c.id !== conversationId));

      toast.success(SUCCESS_MESSAGES.SESSION_DELETED);
    },
    [getAccessToken]
  );

  useEffect(() => {
    fetchAll();
  }, [fetchAll]);

  return {
    recentChats,
    olderChats,
    allOlderChats,
    loading,

    hasMoreRecent,
    hasMoreOlder,
    hasMoreAllOlder,

    loadMoreRecent,
    loadMoreOlder,
    loadMoreAllOlder,

    loadingMoreRecent,
    loadingMoreOlder,
    loadingMoreAllOlder,

    // On-demand section fetch (for lazy loading)
    fetchOlderSection,
    fetchAllOlderSection,
    loadingOlderSection,
    loadingAllOlderSection,
    olderFetched,
    allOlderFetched,

    fetchAll,
    renameChat,
    deleteChat,
  };
};

export default UseChatHistory;
